module.exports = __webpack_public_path__ + "static/media/global_modal.79318a69.gif";